import { CIcon } from '~/icons/types'

export const ciEyeDropper: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.4 2.6c-1.5-1.5-3.8-1.5-5.3 0-.5.5-.8 1.1-1 1.7L14.7 6H12c-.2 0-.4.1-.5.2l-.8.8c-.3.3-.3.8 0 1.1l1 1L3.8 17c-.5.4-.8 1.1-.8 1.8 0 .3-.1.6-.3.8l-1 1c-.3.3-.3.8 0 1.1l.8.8c.3.3.8.3 1.1 0l1-1c.1-.4.4-.5.6-.5.7 0 1.3-.3 1.8-.8l7.9-7.9 1 1c.3.3.8.3 1.1 0l.8-.8c.1-.1.2-.3.2-.5V9.3l1.7-.5c.6-.2 1.2-.5 1.7-1 1.5-1.4 1.5-3.7 0-5.2ZM6 19.2c-.2.2-.5.3-.8.3-.3 0-.6.1-.9.2.1-.3.2-.6.2-.9 0-.3.1-.6.3-.8l7.9-7.9 1.2 1.2L6 19.2Z',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'eye-dropper',
  type: 'solid'
}
